import { Flex } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { useTranslation } from "react-i18next";

import { BankCreditOptionsResponse, BankCreditRequestForm } from "types";

import { AddressSection } from "./address-section";

interface CreditRequestPersonalAddressProps {
  form: UseFormReturnType<BankCreditRequestForm>;
  options: BankCreditOptionsResponse;
  visibleFields: string[];
  readOnly?: boolean;
}

export const BankCreditRequestPersonalAddress = ({
  form,
  options,
  visibleFields,
  readOnly = false,
}: CreditRequestPersonalAddressProps) => {
  const { t } = useTranslation();

  return (
    <Flex direction="column" gap="md">
      <AddressSection
        form={form}
        sectionTitle={t("user.address.label")}
        fieldNames={{
          postal: "postal",
          city: "city",
          street: "street",
          houseNumber: "houseNumber",
          canton: "canton",
          livingFrom: "livingFrom",
        }}
        cantonList={options["SwissCanton"]}
        readOnly={readOnly}
      />
      {(visibleFields.includes("previousPostal") ||
        visibleFields.includes("previousCity") ||
        visibleFields.includes("previousStreet") ||
        visibleFields.includes("previousHouseNumber")) && (
        <AddressSection
          form={form}
          sectionTitle={t("user.address.previousLabel")}
          fieldNames={{
            postal: "previousPostal",
            city: "previousCity",
            street: "previousStreet",
            houseNumber: "previousHouseNumber",
            canton: "previousCanton",
          }}
          cantonList={options["SwissCanton"]}
          readOnly={readOnly}
        />
      )}
    </Flex>
  );
};
